import { IAction, StateStatus } from 'redux/utils/common';
import * as Types from './type';

export interface IModal {
  isOpen: boolean;
  data: any;
  type: 'add' | 'edit';
}
export interface IViewModal {
  isOpen: boolean;
  data: any;
}
export interface IState {
  modalAddNew: IModal;
  viewModal: IViewModal;
  addNewTask: {
    status: StateStatus | null;
  };
  updateNewTask: {
    status: StateStatus | null;
  };
  deleteTask: {
    status: StateStatus | null;
  };
  taskList: {
    status: StateStatus | null;
    data: any;
  };
  customerName: {
    status: StateStatus | null;
    data: any;
  };
  assignees: {
    status: StateStatus | null;
    data: any;
  };
  propertyName: {
    status: StateStatus | null;
    data: any;
  };
  viewTask: {
    status: StateStatus | null;
    data: any;
  };
  changeStatusTask: {
    status: StateStatus | null;
  };

  uploadFileTask: {
    data: any;
    status: StateStatus | null;
  };
  uploadFileComment: {
    data: any;
    status: StateStatus | null;
  };
  commentTask: {
    status: StateStatus | null;
  };
  commentsList: {
    status: StateStatus | null;
    data: any;
  };
  likeTask: {
    status: StateStatus | null;
  };
  statusLane: {
    status: StateStatus | null;
    data: any;
  };
  agentName: {
    status: StateStatus | null;
    data: any;
  };
  sharing: {
    status: StateStatus | null;
    data: any;
  };
  reorder: {
    status: StateStatus | null;
  };
}
const initialState: IState = {
  modalAddNew: {
    isOpen: false,
    data: null,
    type: 'add',
  },
  viewModal: {
    isOpen: false,
    data: null,
  },
  addNewTask: {
    status: null,
  },
  updateNewTask: {
    status: null,
  },
  deleteTask: {
    status: null,
  },
  taskList: {
    status: null,
    data: null,
  },
  customerName: {
    status: null,
    data: null,
  },
  assignees: {
    status: null,
    data: null,
  },
  propertyName: {
    status: null,
    data: null,
  },
  viewTask: {
    status: null,
    data: null,
  },
  changeStatusTask: {
    status: null,
  },
  uploadFileTask: {
    data: null,
    status: null,
  },
  uploadFileComment: {
    data: null,
    status: null,
  },
  commentTask: {
    status: null,
  },
  commentsList: {
    status: null,
    data: null,
  },
  likeTask: {
    status: null,
  },
  statusLane: {
    status: null,
    data: null,
  },
  agentName: {
    status: null,
    data: null,
  },
  sharing: {
    status: null,
    data: null,
  },
  reorder: {
    status: null,
  },
};

const TaskReducer = (state: IState = initialState, action: IAction): IState => {
  switch (action.type) {
    case Types.SET_MODAL_ADD_NEW:
      return {
        ...state,
        modalAddNew: {
          ...state.modalAddNew,
          ...action.data,
        },
      };
    case Types.SET_MODAL_VIEW_TASK:
      return {
        ...state,
        viewModal: {
          ...state.viewModal,
          ...action.data,
        },
      };

    case Types.ADD_NEW_TASK:
      return {
        ...state,
        addNewTask: {
          ...state.addNewTask,
          status: action.status || null,
        },
      };
    case Types.UPDATE_TASK:
      return {
        ...state,
        updateNewTask: {
          ...state.updateNewTask,
          status: action.status || null,
        },
      };
    case Types.DELETE_TASK:
      return {
        ...state,
        deleteTask: {
          ...state.deleteTask,
          status: action.status || null,
        },
      };

    case Types.SET_TASK_LIST:
      return {
        ...state,
        taskList: {
          ...state.taskList,
          status: action.status || null,
          data: action.data,
        },
      };
    case Types.SET_CUSTOMER_NAME:
      return {
        ...state,
        customerName: {
          ...state.customerName,
          status: action.status || null,
          data: action.data,
        },
      };
    case Types.SET_ASSIGNESS:
      return {
        ...state,
        assignees: {
          ...state.assignees,
          status: action.status || null,
          data: action.data,
        },
      };
    case Types.SET_PROPERTY_NAME:
      return {
        ...state,
        propertyName: {
          ...state.propertyName,
          status: action.status || null,
          data: action.data,
        },
      };
    case Types.SET_VIEW_TASK:
      return {
        ...state,
        viewTask: {
          ...state.viewTask,
          status: action.status || null,
          data: action.data,
        },
      };
    case Types.CHANGE_STATUS_TASK:
      return {
        ...state,
        changeStatusTask: {
          ...state.changeStatusTask,
          status: action.status || null,
        },
      };

    case Types.UPLOAD_FILE_TASK:
      return {
        ...state,
        uploadFileTask: {
          ...state.uploadFileTask,
          status: action.status || null,
          data: action.data,
        },
      };
    case Types.UPLOAD_FILE_COMMENT:
      return {
        ...state,
        uploadFileComment: {
          ...state.uploadFileComment,
          status: action.status || null,
          data: action.data,
        },
      };
    case Types.COMMENT_TASK:
      return {
        ...state,
        commentTask: {
          ...state.commentTask,
          status: action.status || null,
        },
      };
    case Types.SET_COMMENT_TASK:
      return {
        ...state,
        commentsList: {
          ...state.commentsList,
          status: action.status || null,
          data: action.data,
        },
      };
    case Types.LIKE_TASK:
      return {
        ...state,
        likeTask: {
          ...state.likeTask,
          status: action.status || null,
        },
      };

    case Types.SET_STATUS_LANE:
      return {
        ...state,
        statusLane: {
          ...state.statusLane,
          status: action.status || null,
          data: action.data,
        },
      };
    case Types.SET_AGENT_NAME:
      return {
        ...state,
        agentName: {
          ...state.agentName,
          status: action.status || null,
          data: action.data,
        },
      };
    case Types.SET_SHARING_TASK:
      return {
        ...state,
        sharing: {
          data: action.data,
          status: action.status || null,
        },
      };
    case Types.REORDER_TASK:
      return {
        ...state,
        reorder: {
          status: action.status || null,
        },
      };
    default:
      return {
        ...state,
      };
  }
};

export default TaskReducer;
